import { render } from "./BreadcrumbsComponent.vue?vue&type=template&id=095fd610&scoped=true"
import script from "./BreadcrumbsComponent.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsComponent.vue?vue&type=script&lang=js"

import "./BreadcrumbsComponent.vue?vue&type=style&index=0&id=095fd610&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095fd610"]])

export default __exports__